import { message, Select, Tabs, Switch, Checkbox, Button } from "antd";
import { FileTextOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  ButtonItem,
  InputItem,
  ErrorItem,
  SelectItem,
  ImporteTab,
  cuentaMask
} from "../../../../Components/Items";
import {
  etiquetaAplicarAEmpleados,
  avisoOmitidosAplicar,
  textoResultadoEmpleados,
} from "../textosEmpleadosConcepto";
import GuiaConceptosLey from "../GuiaConceptosLey/GuiaConceptosLey";
import { aplicarConceptoLey } from "../aplicarConceptoLey";

const { Option } = Select;
const { TabPane } = Tabs;

class EditarConceptoNomina extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    visible: this.props.visible,
    tipo: null,
    noSuma: false,
    automaticoGlobal: false,
    // Estado del concepto: la casilla de empleados no se ofrece para uno deshabilitado,
    // porque el motor los filtra al calcular y asignarlo no haría nada.
    conceptoEstado: null,
    // null = todavía no se pregunta. Sólo se consulta cuando el usuario marca la casilla.
    conteoEmpleados: null,
    consultandoConteo: false,
    tiposConceptoSat: [],
    objetoCuentaContable: [],
    // Espejo del switch de préstamo: setFieldsValue no dispara el onChange, y en Editar el campo
    // SIEMPRE se llena por código, así que sin esto el select del concepto de cobro no aparecería.
    esPrestamoPercepcion: false,
    // Espejo del switch «No contabilizar», por el mismo motivo: esconde los campos de cuentas.
    noContabiliza: false,
    // Deducciones de la empresa, para el select de «Concepto que cobra el préstamo».
    opcionesCobroPrestamo: [],
    activeTab: "1",
    // Espejo del campo del form: la guía legal necesita la clave SAT elegida, y el
    // valor del Form no es legible desde el render.
    tipoConceptoSatId: null,
    guiaLey: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible, activeTab: "1" });
      if (this.props.visible && this.props.conceptoNominaId) {
        this.formRef.current && this.formRef.current.resetFields();
        // Los flags de la casilla de empleados se limpian aquí a fuerza: si el usuario cerró
        // con la casilla prendida y abre OTRO concepto, se quedaría prendida sobre uno que
        // nunca eligió. resetFields() limpia el Form, no el estado espejo.
        this.setState({
          tipo: null, automaticoGlobal: false, conceptoEstado: null,
          conteoEmpleados: null, consultandoConteo: false,
          tipoConceptoSatId: null, guiaLey: false,
          esPrestamoPercepcion: false, noContabiliza: false,
        });
        this.consultarDatos(() => {
          this.consultarDatosConcepto(this.props.conceptoNominaId);
        });
      }
    }
  }

  consultarDatos(callback) {
    this.setState({ loading: true });
    axios
      .post(
        "conceptosNomina/selectDatosParaConceptoNomina",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ tiposConceptoSat: res.data.tiposConceptoSat }, callback);
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al cargar los datos");
      });

    // selectTodasCuentasContables y no selectCuentasContablesFinales: este último sólo
    // devuelve cuentas hoja, y una cuenta de pasivo con "Generar cuenta por empleado"
    // deja de serlo en cuanto genera su primera subcuenta — con la lista de finales la
    // cuenta configurada desaparecía del desplegable y el campo se veía vacío.
    axios
      .post(
        "cuentascontables/selectTodasCuentasContables",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404 || !Array.isArray(res.data)) return;
        this.setState({
          objetoCuentaContable: res.data.filter((value) => value).map((value) => (
            <Option value={value._id} key={value._id}>
              {cuentaMask((value.nivel1 || "") + (value.nivel2 || "") + (value.nivel3 || "") + (value.nivel4 || "") + (value.nivel5 || "")) + " - " + value.descripcion}
            </Option>
          )),
        });
      });

    // Deducciones que pueden cobrar un préstamo entregado en la nómina. No se filtran las que no
    // tienen cuenta de pasivo —se marcan— para que la que ya estuviera configurada siempre
    // aparezca en el desplegable en vez de mostrarse como un ObjectId pelón; el backend la
    // rechaza al guardar y Verificar Contabilidad lo advierte.
    axios
      .post(
        "conceptosNomina/selectAllConceptosNomina",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2 || !Array.isArray(res.data.data)) return;
        this.setState({
          opcionesCobroPrestamo: res.data.data
            .filter((c) => c.tipo === 2 && !c.noSuma)
            .map((c) => (
              <Option value={c._id} key={c._id}>
                {`${c.numeroConcepto != null ? c.numeroConcepto : c.numero} - ${c.descripcion}` +
                  (c.cuentaPasivoId ? "" : " (sin cuenta de pasivo)")}
              </Option>
            )),
        });
      });
  }

  consultarDatosConcepto(id) {
    this.setState({ loading: true });
    axios
      .post(
        "conceptosNomina/datosConceptoNomina",
        { conceptoNominaId: id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success !== 2) {
          message.error("No se encontraron los datos del concepto");
        } else {
          const d = res.data.data;
          // automaticoGlobal se espeja en el estado porque el setFieldsValue de abajo NO
          // dispara el onChange del Switch. Aquí es todavía más importante que en el alta:
          // en Editar el switch SIEMPRE se llena por código, nunca por interacción, así que
          // sin esto la casilla de empleados no aparecería jamás.
          this.setState({
            tipo: d.tipo,
            noSuma: !!d.noSuma,
            automaticoGlobal: !!d.automaticoGlobal,
            conceptoEstado: d.estado,
            tipoConceptoSatId: d.tipoConceptoSatId,
            esPrestamoPercepcion: !!d.esPrestamoPercepcion,
            noContabiliza: !!d.noContabiliza,
          });
          this.formRef.current && this.formRef.current.setFieldsValue({
            tipo: d.tipo,
            descripcion: d.descripcion,
            leyenda: d.leyenda,
            automaticoGlobal: !!d.automaticoGlobal,
            automaticoLiquidacion: !!d.automaticoLiquidacion,
            tipoConceptoSatId: d.tipoConceptoSatId,
            especie: !!d.especie,
            imprmir: !!d.imprmir,
            noSuma: !!d.noSuma,
            tipoPercepcionSatId: d.tipoPercepcionSatId,
            // Importe Total
            nombreImporteTotal: d.nombreImporteTotal,
            formulaImporteTotal: d.formulaImporteTotal,
            acumuladosFiscalesImporteTotal: d.acumuladosFiscalesImporteTotal,
            otrosAcumuladosImporteTotal: d.otrosAcumuladosImporteTotal,
            // Importe 1
            nombreImporte1: d.nombreImporte1,
            formulaImporte1: d.formulaImporte1,
            acumuladosFiscalesImporte1: d.acumuladosFiscalesImporte1,
            otrosAcumuladosImporte1: d.otrosAcumuladosImporte1,
            // Importe 2
            nombreImporte2: d.nombreImporte2,
            formulaImporte2: d.formulaImporte2,
            acumuladosFiscalesImporte2: d.acumuladosFiscalesImporte2,
            otrosAcumuladosImporte2: d.otrosAcumuladosImporte2,
            // Importe 3
            nombreImporte3: d.nombreImporte3,
            formulaImporte3: d.formulaImporte3,
            acumuladosFiscalesImporte3: d.acumuladosFiscalesImporte3,
            otrosAcumuladosImporte3: d.otrosAcumuladosImporte3,
            // Importe 4
            nombreImporte4: d.nombreImporte4,
            formulaImporte4: d.formulaImporte4,
            acumuladosFiscalesImporte4: d.acumuladosFiscalesImporte4,
            otrosAcumuladosImporte4: d.otrosAcumuladosImporte4,
            // Extras (banderas de sistema)
            esVacaciones: !!d.esVacaciones,
            esPrimaVacacional: !!d.esPrimaVacacional,
            esSueldo: !!d.esSueldo,
            esSeptimoDia: !!d.esSeptimoDia,
            esCreditoInfonvitCF: !!d.esCreditoInfonvitCF,
            esCreditoInfonvitFD: !!d.esCreditoInfonvitFD,
            esCreditoInfonvitPORC: !!d.esCreditoInfonvitPORC,
            esSeguroViviendaInfonvit: !!d.esSeguroViviendaInfonvit,
            esAjusteAlNeto: !!d.esAjusteAlNeto,
            esIngresoAsimilados: !!d.esIngresoAsimilados,
            esHorasExtra: !!d.esHorasExtra,
            esPercepcionArt174: !!d.esPercepcionArt174,
            // Va SIEMPRE, aunque el switch sea de sólo lectura: onFinish manda los campos
            // registrados, así que sin este initialValue viajaría undefined y Mongoose 5
            // (omitUndefined en false) lo escribiría — apagándole el blindaje al concepto
            // cada vez que alguien lo abriera y guardara.
            soloAsignacionExplicita: !!d.soloAsignacionExplicita,
            // Contabilidad
            // Mismo motivo que soloAsignacionExplicita: sin initialValue viajaría undefined
            // y Mongoose lo escribiría, apagando la bandera al abrir y guardar el concepto.
            noContabiliza: !!d.noContabiliza,
            cuentaCostoGastoId: d.cuentaCostoGastoId,
            cuentaPasivoId: d.cuentaPasivoId,
            generarCuentaPorEmpleado: !!d.generarCuentaPorEmpleado,
            esPrestamoPercepcion: !!d.esPrestamoPercepcion,
            conceptoCobroPrestamoId: d.conceptoCobroPrestamoId,
          });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  onFinishFailed(e) { ErrorItem(e); }

  // Escribe en el form lo que trae una ficha de la Guía Legal. La clave SAT se resuelve
  // aquí porque el catálogo del SAT lo tiene esta pantalla, no la guía.
  aplicarDesdeGuia = (concepto, formulas, todo) => {
    const sat = this.state.tiposConceptoSat.find(
      (t) => t.c_TipoPercepcion === concepto.clave && t.tipo === concepto.tipo
    );
    aplicarConceptoLey({
      formRef: this.formRef,
      concepto,
      formulas,
      todo,
      empresaId: this.props.empresaId,
      headersToken: this.props.headersToken,
      tipoFormulario: this.state.tipo,
      satIdParaClave: sat?._id,
      onAplicado: ({ tipoConceptoSatId }) => {
        // setFieldsValue no dispara el onChange del select, así que el espejo se actualiza aquí.
        if (tipoConceptoSatId) this.setState({ tipoConceptoSatId });
        // Al aplicar todo se cierra la guía y se muestra el Importe Total, para que el
        // usuario vea de una vez lo que se escribió en lugar de quedarse en la General.
        if (todo) this.setState({ guiaLey: false, activeTab: "2" });
      },
    });
  };

  // Se dispara sólo cuando el usuario marca la casilla, no al abrir el modal: si nadie la
  // marca, no se consulta la base ni una vez. La dirección la manda el switch tal como está
  // en pantalla, que es la que se va a guardar.
  consultarConteoEmpleados = () => {
    this.setState({ consultandoConteo: true });
    axios
      .post(
        "conceptosNomina/conteoEmpleadosParaConcepto",
        {
          empresaId: this.props.empresaId,
          conceptoNominaId: this.props.conceptoNominaId,
          automaticoGlobal: this.state.automaticoGlobal,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        const conteo = res.data.success === 2 ? res.data : null;
        this.setState({ consultandoConteo: false, conteoEmpleados: conteo });
        // Si no hay a quién aplicárselo, la casilla se desmarca sola: dejarla marcada y
        // deshabilitada mandaría al backend una instrucción que no puede hacer nada.
        if (conteo && conteo.afectables === 0) {
          this.formRef.current?.setFieldsValue({ aplicarAEmpleadosExistentes: false });
        }
      })
      .catch(() => this.setState({ consultandoConteo: false, conteoEmpleados: null }));
  };

  onChangeAplicarAEmpleados = (e) => {
    if (e.target.checked && !this.state.conteoEmpleados && !this.state.consultandoConteo) {
      this.consultarConteoEmpleados();
    }
  };

  // Cambiar el switch invierte lo que hace la casilla (agregar ↔ quitar), así que se desmarca
  // y se tira el conteo: nadie debe ejecutar la dirección contraria a la que estaba leyendo.
  onChangeAutomaticoGlobal = (val) => {
    this.setState({ automaticoGlobal: val, conteoEmpleados: null });
    if (this.formRef.current) {
      this.formRef.current.setFieldsValue({ aplicarAEmpleadosExistentes: false });
    }
  };

  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "conceptosNomina/editarConceptoNomina",
        {
          ...values,
          conceptoNominaId: this.props.conceptoNominaId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          const detalle = textoResultadoEmpleados(res.data.resultadoEmpleados);
          message.success(
            detalle ? `Concepto actualizado exitosamente. ${detalle}` : "Concepto actualizado exitosamente",
            detalle ? 8 : 3
          );
          this.cerrarModal();
        } else {
          message.error(res.data.message || "No se pudo actualizar el concepto");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al comunicarse con el servidor");
      });
  }

  cerrarModal = () => {
    this.props.cerrarEditarConceptoNomina();
    if (this.formRef.current) this.formRef.current.resetFields();
    this.setState({
      tipo: null, activeTab: "1", automaticoGlobal: false, conceptoEstado: null,
      conteoEmpleados: null, consultandoConteo: false, esPrestamoPercepcion: false,
    });
  };

  render() {
    const {
      tipo, noSuma, tiposConceptoSat, automaticoGlobal, conceptoEstado,
      conteoEmpleados, consultandoConteo, esPrestamoPercepcion, noContabiliza,
    } = this.state;
    const esPercepcion = (tipo === 1 || tipo === 2) && !noSuma;
    // Un concepto deshabilitado no se calcula, así que asignarlo o quitarlo no cambia nada.
    const ofrecerAplicarAEmpleados = conceptoEstado === 1;
    const avisoOmitidos = avisoOmitidosAplicar(automaticoGlobal, conteoEmpleados);
    const sinEmpleadosQueTocar = !!conteoEmpleados && conteoEmpleados.afectables === 0;

    const satFiltrados = tipo === 1
      ? tiposConceptoSat.filter(t => t.tipo === 1 || t.tipo === 3)
      : tipo === 2
      ? tiposConceptoSat.filter(t => t.tipo === 2 || t.tipo === 3)
      : tiposConceptoSat;

    // El registro SAT elegido: de ahí salen la clave y el tipo que abren la ficha de la
    // guía legal. Se usa t.tipo y no el `tipo` del form: una percepción puede llevar una
    // clave de Otro Pago, y la clave sola no identifica al concepto.
    const satSeleccionado = tiposConceptoSat.find((t) => t._id === this.state.tipoConceptoSatId);

    const prefixSat = (t) => t.tipo === 1 ? "P" : t.tipo === 2 ? "D" : "OP";
    const opcionesSat = satFiltrados.map(t => (
      <Option value={t._id} key={t._id}>
        {prefixSat(t) + " - " + t.c_TipoPercepcion + " - " + t.Descripcion}
      </Option>
    ));

    const tabProps = {
      formRef: this.formRef,
      headersToken: this.props.headersToken,
      empresaId: this.props.empresaId,
    };

    return (
      <ModalItem
        title="Editar Concepto de Nómina"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarModal}
        width={1000}
      >
        <Form
          ref={this.formRef}
          name="modalEditarConceptoNomina"
          layout
          bottom={
            <ButtonItem type="primary" htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}>
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <Tabs
            activeKey={this.state.activeTab}
            onChange={(key) => this.setState({ activeKey: key, activeTab: key })}
          >
            <TabPane tab="General" key="1">

              <FormItem name="tipo" label="Tipo" required margin>
                <SelectItem
                  placeholder="Selecciona el tipo"
                  onChange={(value) => {
                    // setFieldsValue no dispara el onChange del select de la clave SAT, así
                    // que el espejo en state hay que limpiarlo aquí o la guía legal seguiría
                    // abriendo la ficha del concepto anterior.
                    this.setState({ tipo: value, tipoConceptoSatId: null });
                    this.formRef.current?.setFieldsValue({ tipoConceptoSatId: undefined });
                    if (value === 2) this.formRef.current?.setFieldsValue({ cuentaCostoGastoId: undefined });
                    // El préstamo entregado en la nómina sólo existe como percepción. El enlace
                    // se limpia con null explícito: con undefined el campo conservaría el valor
                    // anterior en el payload.
                    if (value !== 1) {
                      this.setState({ esPrestamoPercepcion: false });
                      this.formRef.current?.setFieldsValue({
                        esPrestamoPercepcion: false,
                        conceptoCobroPrestamoId: null,
                      });
                    }
                  }}
                >
                  <Option value={1}>Percepción</Option>
                  <Option value={2}>Deducción</Option>
                  <Option value={3}>Obligación</Option>
                </SelectItem>
              </FormItem>

              <FormItem name="descripcion" label="Descripción" margin>
                <InputItem placeholder="Descripción del concepto" />
              </FormItem>

              <FormItem name="leyenda" label="Leyenda" margin>
                <InputItem placeholder="Leyenda para recibo" />
              </FormItem>

              <FormItem
                name="automaticoGlobal"
                label="Automático Global"
                margin
                valuePropName="checked"
                tooltip="Rige el alta de empleados NUEVOS: se les asigna solo. Prenderlo o apagarlo no toca a los que ya están dados de alta — para eso está la casilla de abajo."
              >
                <Switch onChange={this.onChangeAutomaticoGlobal} />
              </FormItem>

              {ofrecerAplicarAEmpleados && (
                <FormItem
                  name="aplicarAEmpleadosExistentes"
                  label=" "
                  colon={false}
                  marginBottom="10px"
                  valuePropName="checked"
                  extra={avisoOmitidos || undefined}
                >
                  <Checkbox onChange={this.onChangeAplicarAEmpleados} disabled={sinEmpleadosQueTocar}>
                    {etiquetaAplicarAEmpleados(automaticoGlobal, conteoEmpleados, consultandoConteo)}
                  </Checkbox>
                </FormItem>
              )}

              <FormItem name="automaticoLiquidacion" label="Automático Liquidación" margin valuePropName="checked">
                <Switch />
              </FormItem>

              {tipo === 1 && (
                <FormItem
                  name="especie"
                  label="Especie"
                  margin
                  valuePropName="checked"
                  tooltip="La percepción se entrega en bienes o servicios, no en dinero: vales, despensa en producto, alimentación, habitación. Se timbra en el CFDI y grava ISR e IMSS como cualquier otra percepción, pero NO suma al neto a pagar ni sale en la dispersión bancaria. Por eso el total del recibo y el del CFDI van a diferir por este importe."
                  extra={
                    noSuma
                      ? "«No Suma» ya deja el concepto fuera de todos los totales y además sin timbrar, así que «Especie» no aplica."
                      : undefined
                  }
                >
                  <Switch disabled={noSuma} />
                </FormItem>
              )}

              <FormItem name="imprmir" label="Imprimir" margin valuePropName="checked">
                <Switch />
              </FormItem>

              <FormItem name="noSuma" label="No Suma" margin valuePropName="checked">
                <Switch onChange={(val) => this.setState({ noSuma: val })} />
              </FormItem>

              <FormItem
                name="tipoConceptoSatId"
                label="Tipo Concepto SAT"
                margin
                tooltip="Selecciona el tipo de concepto SAT"
                required={esPercepcion}
                extra={
                  <Button
                    type="link"
                    size="small"
                    icon={<FileTextOutlined />}
                    onClick={() => this.setState({ guiaLey: true })}
                    style={{ padding: 0, fontSize: 12, height: "auto" }}
                  >
                    {satSeleccionado
                      ? `Qué dice la ley de "${satSeleccionado.Descripcion}" y cómo capturarlo`
                      : "Ver guía legal: qué grava, qué exenta y cómo capturarlo"}
                  </Button>
                }
              >
                <SelectItem
                  placeholder="Selecciona el tipo de concepto SAT"
                  disabled={!esPercepcion}
                  showSearch
                  onChange={(value) => this.setState({ tipoConceptoSatId: value })}
                  filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {opcionesSat}
                </SelectItem>
              </FormItem>
            </TabPane>

            <TabPane tab="Importe Total" key="2">
              <ImporteTab
                nombreField="nombreImporteTotal"
                formulaField="formulaImporteTotal"
                acumFiscField="acumuladosFiscalesImporteTotal"
                otrosAcumField="otrosAcumuladosImporteTotal"
                required
                {...tabProps}
              />
            </TabPane>

            <TabPane tab="Importe 1" key="3">
              <ImporteTab
                nombreField="nombreImporte1"
                formulaField="formulaImporte1"
                acumFiscField="acumuladosFiscalesImporte1"
                otrosAcumField="otrosAcumuladosImporte1"
                {...tabProps}
              />
            </TabPane>

            <TabPane tab="Importe 2" key="4">
              <ImporteTab
                nombreField="nombreImporte2"
                formulaField="formulaImporte2"
                acumFiscField="acumuladosFiscalesImporte2"
                otrosAcumField="otrosAcumuladosImporte2"
                {...tabProps}
              />
            </TabPane>

            <TabPane tab="Importe 3" key="5">
              <ImporteTab
                nombreField="nombreImporte3"
                formulaField="formulaImporte3"
                acumFiscField="acumuladosFiscalesImporte3"
                otrosAcumField="otrosAcumuladosImporte3"
                {...tabProps}
              />
            </TabPane>

            <TabPane tab="Importe 4" key="6">
              <ImporteTab
                nombreField="nombreImporte4"
                formulaField="formulaImporte4"
                acumFiscField="acumuladosFiscalesImporte4"
                otrosAcumField="otrosAcumuladosImporte4"
                {...tabProps}
              />
            </TabPane>

            <TabPane tab="Extras" key="7">
              <p style={{ color: "#888", marginBottom: 16, fontStyle: "italic" }}>
                Banderas internas del sistema. Las que aparecen deshabilitadas identifican al
                concepto reservado de la empresa y las asigna el propio sistema; las editables se
                pueden marcar a mano.
              </p>
              <FormItem name="esVacaciones" label="Es Vacaciones" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem name="esPrimaVacacional" label="Es Prima Vacacional" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem name="esSueldo" label="Es Sueldo" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem name="esSeptimoDia" label="Es Séptimo Día" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem name="esCreditoInfonvitCF" label="Es Crédito Infonvit CF" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem name="esCreditoInfonvitFD" label="Es Crédito Infonvit FD" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem name="esCreditoInfonvitPORC" label="Es Crédito Infonvit PORC" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem name="esSeguroViviendaInfonvit" label="Es Seguro Vivienda Infonvit" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem name="esAjusteAlNeto" label="Es Ajuste al Neto" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem name="esIngresoAsimilados" label="Es Ingreso Asimilados a Salarios" margin valuePropName="checked">
                <Switch disabled />
              </FormItem>
              <FormItem
                name="soloAsignacionExplicita"
                label="Sólo por asignación explícita"
                margin
                valuePropName="checked"
                tooltip="Un empleado sin conceptos capturados recibe TODOS los conceptos de la empresa. Con esto activo, éste queda fuera de esa regla: sólo se le calcula a quien lo traiga en su lista. Es lo que evita que un concepto de un régimen concreto —como el ingreso de asimilados a salarios— le salga a toda la plantilla."
              >
                <Switch />
              </FormItem>
              <FormItem
                name="esHorasExtra"
                label="Es Horas Extra"
                margin
                valuePropName="checked"
                tooltip="Marca este concepto para que, al timbrar, se incluya el nodo SAT HorasExtra (Percepciones.Percepcion.HorasExtra) con el desglose de horas simples/dobles/triples capturadas en incidencias."
              >
                <Switch />
              </FormItem>
              {tipo === 1 && (
                <FormItem
                  name="esPercepcionArt174"
                  label="Percepción Art. 174"
                  margin
                  valuePropName="checked"
                  tooltip="Sólo para gratificación anual (aguinaldo), PTU, prima dominical y prima vacacional. Su parte gravada sale de la base ordinaria del periodo y se grava con la tasa efectiva del Art. 174 RLISR en el concepto de deducción 'I.S.R. Art. 174'. Marcarlo en un concepto que no sea de esos cuatro deja ese ingreso sin retención ordinaria."
                >
                  <Switch />
                </FormItem>
              )}
            </TabPane>

            <TabPane tab="Contabilidad" key="8" forceRender>
              <FormItem
                name="noContabiliza"
                label="No contabilizar"
                margin
                valuePropName="checked"
                tooltip="El concepto no genera ningún movimiento en la póliza de nómina y tampoco crea subcuentas por empleado. Úsalo cuando el gasto ya se registró por otro lado — la factura del proveedor de los vales, la salida de almacén — para no duplicarlo."
              >
                <Switch onChange={(val) => this.setState({ noContabiliza: val })} />
              </FormItem>

              {tipo === 1 && !noContabiliza && (
                <FormItem
                  name="esPrestamoPercepcion"
                  label="Préstamo entregado en la nómina"
                  margin
                  valuePropName="checked"
                  tooltip="El concepto entrega un préstamo al empleado dentro del recibo: sube el neto a pagar y su cargo va a la cuenta POR COBRAR del empleado, no a una cuenta de gasto. Por eso se registra al proyecto general y sin traspaso intercentro: un activo no es gasto de un centro de costos."
                >
                  <Switch
                    onChange={(val) => {
                      this.setState({ esPrestamoPercepcion: val });
                      // Sin la opción prendida el backend no guarda el enlace; limpiarlo con null
                      // explícito evita que se quede colgado en el payload.
                      if (!val) this.formRef.current?.setFieldsValue({ conceptoCobroPrestamoId: null });
                    }}
                  />
                </FormItem>
              )}

              {tipo === 1 && !noContabiliza && esPrestamoPercepcion && (
                <FormItem
                  name="conceptoCobroPrestamoId"
                  label="Concepto que cobra el préstamo"
                  margin
                  tooltip="La deducción que descuenta las amortizaciones. De ella salen la cuenta por cobrar y la subcuenta por empleado, para que el cargo de la entrega y los abonos del cobro caigan en la MISMA cuenta y el saldo del préstamo de cada persona se lea directo."
                >
                  <SelectItem
                    placeholder="Selecciona la deducción que lo descuenta"
                    showSearch
                    allowClear
                    filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {this.state.opcionesCobroPrestamo}
                  </SelectItem>
                </FormItem>
              )}

              {(tipo === 1 || tipo === 3) && !noContabiliza && (
                <FormItem
                  name="cuentaCostoGastoId"
                  label={esPrestamoPercepcion ? "Cuenta por cobrar (respaldo)" : "Cuenta de Costo o Gasto"}
                  margin
                  extra={
                    esPrestamoPercepcion
                      ? "Con el concepto de cobro elegido, la cuenta por cobrar sale de él y ésta no se usa. Sólo entra si el enlace se queda sin configurar."
                      : undefined
                  }
                >
                  <SelectItem
                    placeholder={
                      esPrestamoPercepcion
                        ? "Selecciona la cuenta por cobrar al empleado"
                        : "Selecciona la cuenta de costo o gasto"
                    }
                    showSearch
                    filterOption={(input, option) =>
                      option?.children?.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {this.state.objetoCuentaContable}
                  </SelectItem>
                </FormItem>
              )}

              {!noContabiliza && (
              <FormItem name="cuentaPasivoId" label="Cuenta de Pasivo" margin>
                <SelectItem placeholder="Selecciona la cuenta de pasivo" showSearch
                  filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {this.state.objetoCuentaContable}
                </SelectItem>
              </FormItem>
              )}

              {!noContabiliza && (
              <FormItem
                name="generarCuentaPorEmpleado"
                label="Generar cuenta por empleado"
                margin
                valuePropName="checked"
                tooltip="Al timbrar la nómina, se genera una subcuenta de la cuenta de pasivo para cada empleado. No aplica al cargo de un préstamo entregado en la nómina: ése usa la subcuenta del concepto que lo cobra."
              >
                <Switch />
              </FormItem>
              )}
            </TabPane>
          </Tabs>
        </Form>

        <GuiaConceptosLey
          visible={this.state.guiaLey}
          claveSat={satSeleccionado?.c_TipoPercepcion}
          tipo={satSeleccionado?.tipo}
          onClose={() => this.setState({ guiaLey: false })}
          onAplicar={this.aplicarDesdeGuia}
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(EditarConceptoNomina);